import * as React from 'react'
import moment from 'moment'
import type { Moment } from 'moment'

import { OutputType } from 'app/constants/outputType'

import { AdminDateField, CheckboxField } from '@/modules/shared/components'
import { Dropdown } from '@/app/features/company-selection/Dropdown'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import { AdminModal, AdminModalRow } from '../shared/AdminModal'

const SORT_BY_OPTIONS = [
  { name: 'demo-companies-report.sort-by-date', type: 0 },
  { name: 'demo-companies-report.sort-by-company', type: 1 },
]

type Props = {
  getDemoReport: (
    startDate: Moment,
    endDate: Moment,
    outputType: OutputType,
    sortBy: number,
  ) => any
  onClose: () => void
}

/** Wydruk firm demo - funkcyjny odpowiednik `printout/demoCompaniesModal.tsx`. */
export const DemoCompaniesModal: React.FC<Props> = ({
  getDemoReport,
  onClose,
}) => {
  const { t } = useLocalize()
  const [isCsv, setIsCsv] = React.useState(false)
  const [dateFrom, setDateFrom] = React.useState<Moment>(
    moment().add(-1, 'months'),
  )
  const [dateTo, setDateTo] = React.useState<Moment>(moment())
  const [sortBy, setSortBy] = React.useState(0)

  return (
    <AdminModal
      title={t('demo-companies-report.title')}
      onClose={onClose}
      onConfirm={() => {
        onClose()
        getDemoReport(
          dateFrom,
          dateTo,
          isCsv ? OutputType.Csv : OutputType.Pdf,
          sortBy,
        )
      }}
    >
      <AdminModalRow label={t('demo-companies-report.period')}>
        <div className="tw-flex tw-items-center tw-gap-2">
          <div className="tw-w-[190px]">
            <AdminDateField
              withTime
              value={dateFrom}
              onChange={(date) => date && setDateFrom(moment(date))}
            />
          </div>
          <span>-</span>
          <div className="tw-w-[190px]">
            <AdminDateField
              withTime
              value={dateTo}
              onChange={(date) => date && setDateTo(moment(date))}
            />
          </div>
        </div>
      </AdminModalRow>

      <AdminModalRow label={t('demo-companies-report.sort-by')}>
        <Dropdown
          compact
          value={String(sortBy)}
          options={SORT_BY_OPTIONS.map((option) => ({
            value: String(option.type),
            label: t(option.name),
          }))}
          onChange={(value) => setSortBy(Number(value))}
        />
      </AdminModalRow>

      <CheckboxField
        id="isCsv"
        checked={isCsv}
        label={t('demo-companies-report.isCsv')}
        onChange={() => setIsCsv((value) => !value)}
      />
    </AdminModal>
  )
}
